module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Medium.c8487ee2.woff";